import { FC, ReactNode, useRef } from "react";
import { Transition } from "react-transition-group";
import "./PopupModal.scss";
import SVG_ENUM from "../../enums/SvgEnum";
import { SVG } from "..";

interface PopupModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

const PopupModal: FC<PopupModalProps> = ({
  isOpen,
  onClose,
  children,
  className = "",
}) => {
  const duration = 300;
  const nodeRef = useRef<HTMLDivElement>(null);

  const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
  };

  const transitionStyles: { [key: string]: React.CSSProperties } = {
    entering: { opacity: 0, pointerEvents: "none" },
    entered: { opacity: 1, pointerEvents: "auto" },
    exiting: { opacity: 0, pointerEvents: "none" },
    exited: { opacity: 0, pointerEvents: "none" },
  };

  return (
    <Transition nodeRef={nodeRef} in={isOpen} timeout={duration}>
      {(state) => (
        <div
          className="popup-modal-overlay"
          onClick={onClose}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          <div
            className={`popup-modal ${className}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popup-modal-content">{children}</div>
            <div className="popup-modal__close" onClick={onClose}>
              <SVG type={SVG_ENUM.CLOSE_CIRCLE} />
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
};

export default PopupModal;
